import { Writable, writable } from "svelte/store";

export const catMap: Writable<Record<string, number>> = writable({});


const defaultFormRetriever: () => Record<string, Record<string, string>>|null = () => ({});
const defaultCouponRetriever: () => Record<string, string> = () => ({});
let formRetriever = defaultFormRetriever;
let couponRetriever = defaultCouponRetriever;

export function getForms(): Record<string, Record<string, string>>|null {
    return formRetriever();
}

export function getCoupons(): Record<string, string> {
    return couponRetriever();
}

export function setFormRetriever(newFormRetriever: (() =>  Record<string, Record<string, string>>|null)|null): void {
    formRetriever = newFormRetriever || defaultFormRetriever;
}

export function setCouponRetriever(newCouponRetriever: (() => Record<string, string>)|null): void {
    couponRetriever = newCouponRetriever || defaultCouponRetriever;
}
